import { render } from "./QuoteForm.vue?vue&type=template&id=0fcfc27a&scoped=true"
import script from "./QuoteForm.vue?vue&type=script&lang=js"
export * from "./QuoteForm.vue?vue&type=script&lang=js"

import "./QuoteForm.vue?vue&type=style&index=0&id=0fcfc27a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcfc27a"]])

export default __exports__